import { useRouter } from 'next/router';
import { useLayoutEffect } from 'react';

const useRemoveEn = () => {
  const router = useRouter();

  useLayoutEffect(() => {
    if (window.location.href.includes('/en/')) {
      router.replace(window.location.href.replace('/en/', '/'));
    }
  }, []);
};

export default useRemoveEn;
